import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(public authService: AuthService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.currentUserValue) {
      this.router.navigate(['login']).then();
      return false;
    } else {
      const currentUser = this.authService.currentUserValue;
      if (currentUser) {
        if (route.data.role && !currentUser.authorityNames.includes(route.data.role.toString())) {
          this.router.navigate(['']).then();
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  }

}
